/* eslint-disable max-len */
/** @jsx jsx */
import moment from 'moment';
import React from 'react';
import { jsx, css } from '@emotion/core';
// import ConfirmActionModal, { ActionType } from 'components/organismos/ConfirmActionModal';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FormContents from 'components/atoms/Form/FormContents';
import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import BodyText from 'components/atoms/BodyText';
import CalendarForm from 'components/molecules/CalendarForm';
import { HopeShiftDomain } from 'domain/master/general/hopeShift';
import BlockUI from 'components/molecules/BlockUi';
import PrimaryButton from 'components/atoms/Button';
import Table from 'components/molecules/Table';
import { textColor, utilityColor, textFontSize } from 'components/styles';
import SelectContextMenu from 'components/molecules/ContextMenu/SelectContextMenu';
import { ContextMenuType } from 'components/molecules/ContextMenu/type';
import ConfirmModal from 'components/organismos/ConfirmModal';
import { AttendShiftPatternDetails } from 'domain/master/general/weekShiftPatternDataStaff';
import { isTablet } from 'react-device-detect';
import { HopeShiftStatus, HopeShiftStatusColor, HopeShiftStatusLabel } from 'api/hopeShift';
import TextInput from 'components/atoms/Form/TextInput';
import useHopeShiftList, { useHopeShift } from './hooks';
import OrganizationFilter from './OrganizationFilter';
import EmploymentFilter from './EmploymentFilter';
import FormPadding from 'components/atoms/Form/FormPadding';
import SelectForm from 'components/molecules/SelectForm';
import FormHeader from 'components/templates/FormHeader';
import ClickableIconButton from 'components/atoms/ClickableIconButton';
import Icon from 'components/atoms/Icon';
import CalendarMonth from 'components/molecules/CalendarV1/CalendarMonth';

const HopeShiftForm: React.FC = () => {
  const { hourFormOptions, timeFormOptions } = useHopeShift();

  const workSystem = sessionStorage.getItem('loginUser.workSystem');

  const {
    formik,
    // fetchData,
    // employmentId,
    // setEmploymentId,
    // orgCode,
    // setOrgCode,
    date,
    setDate,
    blocking,
    confirmModalOpen,
    closeConfirmModal,
    shiftPatternList,
  } = useHopeShiftList();


  function dayOfWeekAsString(dayIndex: number) {
    return ['日', '月', '火', '水', '木', '金', '土'][dayIndex];
  }

  return (
    <React.Fragment>
      <BlockUI blocking={blocking}>
      <FormHeader title="希望シフト" customStyle={css({ marginTop:'0'})}/>
        <FormContents customStyle={css({marginTop:'60px'})}>
            <FormPadding>
            <FlexBox customStyle={css({  paddingTop: '7px', paddingBottom:'8px'})}>
              <FlexBoxItem basis="100px">
                <BodyText> 営業月 </BodyText>
              </FlexBoxItem>
              <FlexBoxItem basis="160px">
                <FlexBox>
                  <FlexBoxItem>
                    <CalendarMonth 
                    openActionChevron={true}
                    date={date}
                    setDate={(d: Date) => { 
                      setDate(d); 
                      sessionStorage.setItem('hopeShift.targetDate', moment(d).format('YYYY/MM/DD'));
                    }}
                    />
                  </FlexBoxItem>
                  {/* <FlexBoxItem>
                    <ClickableIconButton onClick={() => {
                      setDate(new Date(moment(date).subtract(1, 'month').format('YYYY/MM/01')));
                      sessionStorage.setItem('hopeShift.targetDate', moment(date).subtract(1, 'month').format('YYYY/MM/01'));
                    }} additionalCss={css({ marginLeft: '-35px' })}>
                      <Icon type="chevronLeft" color="" size="24px" />
                    </ClickableIconButton>
                  </FlexBoxItem>
                  <FlexBoxItem>
                    <CalendarForm
                      required={true}
                      dateFormat="YYYY/MM"
                      label=""
                      date={date}
                      changeDate={(d: Date) => { setDate(d); }}
                    />
                  </FlexBoxItem>
                  <FlexBoxItem>
                    <ClickableIconButton onClick={() => {
                      setDate(new Date(moment(date).add(1, 'month').format('YYYY/MM/01')));
                      sessionStorage.setItem('hopeShift.targetDate', moment(date).add(1, 'month').format('YYYY/MM/01'));
                    }}>
                      <Icon type="chevronRight" color="" size="24px" />
                    </ClickableIconButton>
                  </FlexBoxItem> */}
                </FlexBox>
              </FlexBoxItem>
            </FlexBox>
            <OrganizationFilter
              orgCode=""
              setOrgCode={(arg: string) => {
                // sessionStorage.setItem('selectedOrgCodeStaffMaster', arg);
                // setOrgCode(arg);
              }}
            />

            <EmploymentFilter
              employmentId=""
              setEmploymentId={(arg: string) => {
                // sessionStorage.setItem('selectedEmploymentIdStaffMaster', arg);
                // setEmploymentId(arg);
              }}
            />
            </FormPadding>

          <div className="table-responsive" style={{ margin: '15px 15px 45px' }}>
            <table id="monthHourList" className="table table-bordered table-condensed" cellSpacing="0" style={{ whiteSpace: 'nowrap', width: '100%' }}>
              <thead>
                <tr>
                  <th style={{ width: '12%', color: textColor.main }}>
                    日付
                  </th>
                  <th style={{ width: '10%', color: textColor.main }}>
                    ステータス
                  </th>
                  <th style={{ width: '14%', color: textColor.main }}>
                    出勤可否
                  </th>
                  <th style={{ width: '23%', color: textColor.main }}>
                    開始時間
                  </th>
                  <th style={{ width: '23%', color: textColor.main }}>
                    終了時間
                  </th>
                  <th style={{ width: '18%', color: textColor.main }}>
                    備考
                  </th>
                </tr>
              </thead>
              <tbody>
                {formik.values.map((hopeShift: HopeShiftDomain, index: number) => {
                  const subMenuButtons: ContextMenuType[] = shiftPatternList.map((selectedShiftPattern) => {
                    const subMenuButton: ContextMenuType = {
                      isRed: false,
                      isSelectable: true,
                      label: selectedShiftPattern.shiftPatternNameDisp,
                      isHidden: false,
                      stamptype: 0,
                      onClick: () => {
                        const edittedHopeShiftList = formik.values.map(((hopeShiftItem: HopeShiftDomain) => {
                          if (hopeShiftItem.targetDate === hopeShift.targetDate) {
                            // Get end time
                            const shiftDetailEnd: AttendShiftPatternDetails = selectedShiftPattern.attendShiftPatternDetails[selectedShiftPattern.attendShiftPatternDetails.length - 1];
                            const [hours, minutes, seconds] = shiftDetailEnd.endTime.split(':');
                            const endTime = new Date(hopeShiftItem.targetDate);
                            if (shiftDetailEnd.isEndTimeNextDay) {
                              endTime.setDate(endTime.getDate() + 1);
                            }
                            endTime.setHours(Number(hours));
                            endTime.setMinutes(Number(minutes));
                            endTime.setSeconds(Number(seconds));
                            // Get start time
                            const shiftDetailStart: AttendShiftPatternDetails = selectedShiftPattern.attendShiftPatternDetails[0];
                            const [h, m, s] = shiftDetailStart.startTime.split(':');
                            const startTime = new Date(hopeShiftItem.targetDate);
                            if (shiftDetailStart.isStartTimeNextDay) {
                              startTime.setDate(endTime.getDate() + 1);
                            }
                            startTime.setHours(Number(h));
                            startTime.setMinutes(Number(m));
                            startTime.setSeconds(Number(s));


                            const editedHopeShift: HopeShiftDomain = hopeShift;
                            editedHopeShift.shiftPatternId = selectedShiftPattern.shiftPatternId;
                            editedHopeShift.startTime = startTime;
                            editedHopeShift.endTime = endTime;
                            editedHopeShift.fixStatus = HopeShiftStatus.UNSUBMITED;
                            editedHopeShift.hopeShiftPatternType = 3;

                            return editedHopeShift;
                          }
                          return hopeShiftItem;
                        }));

                        formik.setValues(edittedHopeShiftList);
                      },
                    };
                    return subMenuButton;
                  });
                  const contextMenuCantWork: ContextMenuType = {
                    isRed: false,
                    isSelectable: true,
                    label: '出勤できません',
                    isHidden: false,
                    subMenu: undefined,
                    stamptype: 0,
                    onClick: () => {
                      const edittedHopeShiftList = formik.values.map(((hopeShiftItem: HopeShiftDomain) => {
                        if (hopeShiftItem.targetDate === hopeShift.targetDate) {
                          const editedHopeShift: HopeShiftDomain = hopeShift;
                          editedHopeShift.shiftPatternId = '';
                          editedHopeShift.startTime = null;
                          editedHopeShift.endTime = null;
                          editedHopeShift.fixStatus = HopeShiftStatus.UNSUBMITED;
                          editedHopeShift.hopeShiftPatternType = 2;

                          return editedHopeShift;
                        }
                        return hopeShiftItem;
                      }));

                      formik.setValues(edittedHopeShiftList);
                    },
                  };

                  const contextMenuHoliday: ContextMenuType = formik.values[0].distinctionHoliday
                    ? {
                      label: "公休",
                      isRed: false,
                      isSelectable: true,
                      stamptype: 0,
                      subMenu: [
                        {
                          label: "法定休日",
                          isRed: false,
                          isSelectable: true,
                          stamptype: 0,
                          onClick: () => {
                            const edittedHopeShiftList = formik.values.map(((hopeShiftItem: HopeShiftDomain) => {
                              if (hopeShiftItem.targetDate === hopeShift.targetDate) {
                                const editedHopeShift: HopeShiftDomain = hopeShift;
                                editedHopeShift.shiftPatternId = '';
                                editedHopeShift.startTime = null;
                                editedHopeShift.endTime = null;
                                editedHopeShift.fixStatus = HopeShiftStatus.UNSUBMITED;
                                editedHopeShift.hopeShiftPatternType = 4;

                                return editedHopeShift;
                              }
                              return hopeShiftItem;
                            }));

                            formik.setValues(edittedHopeShiftList);
                          },
                        },
                        {
                          label: "所定休日",
                          isRed: false,
                          isSelectable: true,
                          stamptype: 0,
                          onClick: () => {
                            const edittedHopeShiftList = formik.values.map(((hopeShiftItem: HopeShiftDomain) => {
                              if (hopeShiftItem.targetDate === hopeShift.targetDate) {
                                const editedHopeShift: HopeShiftDomain = hopeShift;
                                editedHopeShift.shiftPatternId = '';
                                editedHopeShift.startTime = null;
                                editedHopeShift.endTime = null;
                                editedHopeShift.fixStatus = HopeShiftStatus.UNSUBMITED;
                                editedHopeShift.hopeShiftPatternType = 5;

                                return editedHopeShift;
                              }
                              return hopeShiftItem;
                            }));

                            formik.setValues(edittedHopeShiftList);
                          },
                        },
                      ],
                    }
                    : {
                      label: "公休",
                      isRed: false,
                      isSelectable: true,
                      stamptype: 0,
                      onClick: () => {
                        const edittedHopeShiftList = formik.values.map(((hopeShiftItem: HopeShiftDomain) => {
                          if (hopeShiftItem.targetDate === hopeShift.targetDate) {
                            const editedHopeShift: HopeShiftDomain = hopeShift;
                            editedHopeShift.shiftPatternId = '';
                            editedHopeShift.startTime = null;
                            editedHopeShift.endTime = null;
                            editedHopeShift.fixStatus = HopeShiftStatus.UNSUBMITED;
                            editedHopeShift.hopeShiftPatternType = 4;

                            return editedHopeShift;
                          }
                          return hopeShiftItem;
                        }));

                        formik.setValues(edittedHopeShiftList);
                      },
                    };


                  const selectAll: ContextMenuType = {
                    isRed: false,
                    isSelectable: true,
                    label: '-',
                    isHidden: false,
                    subMenu: undefined,
                    stamptype: 0,
                    onClick: () => {
                      const edittedHopeShiftList = formik.values.map(((hopeShiftItem: HopeShiftDomain) => {
                        if (hopeShiftItem.targetDate === hopeShift.targetDate) {
                          const editedHopeShift: HopeShiftDomain = hopeShift;
                          editedHopeShift.shiftPatternId = '';
                          editedHopeShift.startTime = null;
                          editedHopeShift.endTime = null;
                          editedHopeShift.fixStatus = HopeShiftStatus.UNSUBMITED;
                          editedHopeShift.hopeShiftPatternType = 0;

                          return editedHopeShift;
                        }
                        return hopeShiftItem;
                      }));

                      formik.setValues(edittedHopeShiftList);
                    },
                  };

                  const contextMenuShiftPattern: ContextMenuType = {
                    isRed: false,
                    isSelectable: false,
                    showSearchBox: true,
                    label: 'シフトパターン',
                    isHidden: false,
                    subMenu: subMenuButtons,
                    stamptype: 0,
                    onClick: () => {
                    },
                  };

                  const contextMenus1: ContextMenuType[] = [selectAll, contextMenuCantWork, contextMenuHoliday, contextMenuShiftPattern];
                  // const contextMenus2: ContextMenuType[] = [selectAll, contextMenuCantWork, contextMenuShiftPattern];
                  return (

                    <tr role="row">
                      <Table.Cell customStyle={css({ textAlign: 'center' })}>
                        {`${moment(hopeShift.targetDate).format('MM月DD日 ')}(${dayOfWeekAsString(new Date(hopeShift.targetDate).getDay())})`}
                      </Table.Cell>
                      <Table.Cell>
                        <FlexBox customStyle={css({ textAlign: 'center' })}>
                          <FlexBoxItem width="100%">
                            <div style={{
                              backgroundColor: HopeShiftStatusColor[hopeShift.fixStatus],
                              fontSize: textFontSize.sm,
                              borderRadius: '3px',
                              padding: '5px',
                              color: utilityColor.white,
                            }}
                            >
                              {HopeShiftStatusLabel[hopeShift.fixStatus]}
                            </div>
                          </FlexBoxItem>
                        </FlexBox>
                      </Table.Cell>
                      <Table.Cell>
                        <SelectContextMenu
                          text={hopeShift.hopeShiftPatternType === 2 ? '出勤できません'
                            : hopeShift.hopeShiftPatternType === 4 ? formik.values[0].distinctionHoliday ? '法定休日' : '公休'
                              : hopeShift.hopeShiftPatternType === 5 ? '所定休日'
                                : shiftPatternList.find((item) => item.shiftPatternId === hopeShift.shiftPatternId)?.shiftPatternNameDisp || '-'}
                          buttons={contextMenus1}
                          disable={Number(workSystem) === 3 ? true : hopeShift.fixStatus === HopeShiftStatus.APPROVED}
                        />
                      </Table.Cell>
                      <Table.Cell>
                        <FlexBox customStyle={css({ placeContent: 'center' })}>
                          <FlexBoxItem width="100%">
                            <VerticalLabelSelectForm
                              name="startTimeHour"
                              value={hopeShift.startTime ? moment(hopeShift.startTime).format('HH') : '-'}
                              setValue={(val: string) => {
                                const edittedHopeShiftList = formik.values.map(((item: any) => {
                                  if (item.targetDate === hopeShift.targetDate) {
                                    const editedHopeShift: HopeShiftDomain = hopeShift;

                                    const newDate = editedHopeShift.startTime ? new Date(editedHopeShift.startTime) : new Date(item.targetDate);
                                    newDate.setHours(Number(val));
                                    editedHopeShift.startTime = newDate;
                                    return editedHopeShift;
                                  }
                                  return item;
                                }));

                                formik.setValues(edittedHopeShiftList);
                              }}
                              options={hourFormOptions}
                              disable={true}
                            />
                          </FlexBoxItem>
                          <FlexBoxItem marginLeft={isTablet ? '2px' : '7px'} marginRight={isTablet ? '2px' : '7px'}>
                            :
                          </FlexBoxItem>
                          <FlexBoxItem width="100%">
                            <VerticalLabelSelectForm
                              name="startTimeMinutes"
                              value={hopeShift.startTime ? moment(hopeShift.startTime).format('mm') : '-'}
                              setValue={(val: string) => {
                                const edittedHopeShiftList = formik.values.map(((item: any) => {
                                  if (item.targetDate === hopeShift.targetDate) {
                                    const editedHopeShift: HopeShiftDomain = hopeShift;

                                    const newDate = editedHopeShift.startTime ? new Date(editedHopeShift.startTime) : new Date(item.targetDate);
                                    newDate.setMinutes(Number(val));
                                    editedHopeShift.startTime = newDate;
                                    return editedHopeShift;
                                  }
                                  return item;
                                }));
                                formik.setValues(edittedHopeShiftList);
                              }}
                              options={timeFormOptions}
                              disable={true}
                            />
                          </FlexBoxItem>
                        </FlexBox>
                      </Table.Cell>
                      <Table.Cell>
                        <FlexBox customStyle={css({ placeContent: 'center' })}>
                          <FlexBoxItem width="100%">
                            <VerticalLabelSelectForm
                              name="endTimeHour"
                              value={hopeShift.endTime ? moment(hopeShift.endTime).format('HH') : '-'}
                              setValue={(val: string) => {
                                const edittedHopeShiftList = formik.values.map(((item: any) => {
                                  if (item.targetDate === hopeShift.targetDate) {
                                    const editedHopeShift: HopeShiftDomain = hopeShift;

                                    const newDate = editedHopeShift.endTime ? new Date(editedHopeShift.endTime) : new Date(item.targetDate);
                                    newDate.setHours(Number(val));
                                    editedHopeShift.endTime = newDate;
                                    return editedHopeShift;
                                  }
                                  return item;
                                }));
                                formik.setValues(edittedHopeShiftList);
                              }}
                              options={hourFormOptions}
                              disable={true}
                            />
                          </FlexBoxItem>
                          <FlexBoxItem marginLeft={isTablet ? '2px' : '7px'} marginRight={isTablet ? '2px' : '7px'}>
                            :
                          </FlexBoxItem>
                          <FlexBoxItem width="100%">
                            <VerticalLabelSelectForm
                              name="endTimeMinutes"
                              value={hopeShift.endTime ? moment(hopeShift.endTime).format('mm') : '-'}
                              setValue={(val: string) => {
                                const edittedHopeShiftList = formik.values.map(((item: any) => {
                                  if (item.targetDate === hopeShift.targetDate) {
                                    const editedHopeShift: HopeShiftDomain = hopeShift;

                                    const newDate = editedHopeShift.endTime ? new Date(editedHopeShift.endTime) : new Date(item.targetDate);
                                    newDate.setMinutes(Number(val));
                                    editedHopeShift.endTime = newDate;
                                    return editedHopeShift;
                                  }
                                  return item;
                                }));
                                formik.setValues(edittedHopeShiftList);
                              }}
                              options={timeFormOptions}
                              disable={true}
                            />
                          </FlexBoxItem>
                        </FlexBox>
                      </Table.Cell>
                      <Table.Cell>
                        <TextInput
                          name={`note${index}`}
                          value={hopeShift.note || ''}
                          customStyle={css({ maxWidth: '100%' })}
                          disable={Number(workSystem) === 3 ? true : hopeShift.fixStatus === HopeShiftStatus.APPROVED}
                          onChange={(e) => {
                            const edittedHopeShiftList = formik.values.map(((item: any) => {
                              if (item.targetDate === hopeShift.targetDate) {
                                const editedHopeShift: HopeShiftDomain = hopeShift;
                                editedHopeShift.note = e.target.value;
                                return editedHopeShift;
                              }
                              return item;
                            }));
                            formik.setValues(edittedHopeShiftList);
                          }}
                        />
                      </Table.Cell>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div style={{ margin: '36px', minWidth: '160px', textAlign: 'center' }}>
            <PrimaryButton
              disabled={[2, 3].includes(Number(workSystem)) ? true : false}
              text="提出する"
              onClick={formik.handleSubmit}
            />
          </div>

          <ConfirmModal
            title="確認メッセージ"
            open={confirmModalOpen}
            closeHandler={closeConfirmModal}
            onSubmit={formik.handleSubmit}
            content="希望シフトを提出します。よろしいですか？"
            submitText="提出"
          />
        </FormContents>
      </BlockUI>

    </React.Fragment>
  );
};

export default HopeShiftForm;
